import React, { ReactElement, useEffect, useState } from 'react';

import { DarkMode } from '@sede-x/shell-ds-fabrics/dist/js/darkMode';
import { LightMode } from '@sede-x/shell-ds-fabrics/dist/js/lightMode';
import { Typography } from '@sede-x/shell-ds-fabrics/dist/js/typography';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import { GlobalStyles } from '../../styles/GlobalStyles';
import { DARK_THEME, LIGHT_THEME } from '../../utils/constants';
import { Theme, ThemeMode } from './theme';

export interface IThemeProviderProps {
  theme: ThemeMode;
  children?: React.ReactNode;
}

export const ShellThemeProvider = ({ theme, children }: IThemeProviderProps): ReactElement => {
  const light: Theme = { name: 'light', ...Typography, ...LightMode };
  const dark: Theme = { name: 'dark', ...Typography, ...DarkMode };
  const [currentTheme, setTheme] = useState<Theme>(light);

  useEffect(() => {
    if (theme === LIGHT_THEME) setTheme(light);
    if (theme === DARK_THEME) setTheme(dark);
  }, [theme]);

  return (
    <StyledThemeProvider theme={currentTheme}>
      <>
        <GlobalStyles />
        {children}
      </>
    </StyledThemeProvider>
  );
};
